exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-sm{margin-left:3px;margin-right:3px}.word-container{min-height:60px;line-height:45px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/quiz/question/blanks/question-blanks.component.css
// module id = 469
// module chunks = 1